import { render, staticRenderFns } from "./bonus-points-form.vue?vue&type=template&id=6183d4d8&scoped=true&"
import script from "./bonus-points-form.vue?vue&type=script&lang=js&"
export * from "./bonus-points-form.vue?vue&type=script&lang=js&"
import style0 from "./bonus-points-form.vue?vue&type=style&index=0&id=6183d4d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6183d4d8",
  null
  
)

export default component.exports